import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const SGE = ensureStatuses({
	EUKRASIA: {
		id: 2606,
		name: 'Eukrasia',
		icon: iconUrl(212953),
	},
	EUKRASIAN_DIAGNOSIS: {
		id: 2607,
		name: 'Eukrasian Diagnosis',
		icon: iconUrl(212954),
		duration: 30000,
	},
	DIFFERENTIAL_DIAGNOSIS: {
		id: 2608,
		name: 'Differential Diagnosis',
		icon: iconUrl(212955),
		duration: 30000,
	},
	HAIMA: {
		id: 2612,
		name: 'Haima',
		icon: iconUrl(212958),
		duration: 15000,
	},
	HAIMATINON: {
		id: 2642,
		name: 'Haimatinon',
		icon: iconUrl(217585),
		duration: 15000,
	},
	EUKRASIAN_PROGNOSIS: {
		id: 2609,
		name: 'Eukrasian Prognosis',
		icon: iconUrl(212954),
		duration: 30000,
	},
	PANHAIMA: {
		id: 2613,
		name: 'Panhaima',
		icon: iconUrl(212959),
		duration: 15000,
	},
	PANHAIMATINON: {
		id: 2643,
		name: 'Panhaimatinon',
		icon: iconUrl(217355),
		duration: 15000,
	},
	PHYSIS: {
		id: 2617,
		name: 'Physis',
		icon: iconUrl(212963),
		duration: 15000,
	},
	PHYSIS_II: {
		id: 2620,
		name: 'Physis II',
		icon: iconUrl(212966),
		duration: 15000,
	},
	AUTOPHYSIS: {
		id: 2621,
		name: 'Autophysis',
		icon: iconUrl(212967),
		duration: 15000,
	},
	KARDIA: {
		id: 2604,
		name: 'Kardia',
		icon: iconUrl(212951),
	},
	KARDION: {
		id: 2605,
		name: 'Kardion',
		icon: iconUrl(212952),
	},
	PHILOSOPHIA: {
		id: 3898,
		name: 'Philosophia',
		icon: iconUrl(212974),
		duration: 20000,
	},
	EUDAIMONIA: {
		id: 3899,
		name: 'Eudaimonia',
		icon: iconUrl(212975),
		duration: 20000,
	},
	SOTERIA: {
		id: 2610,
		name: 'Soteria',
		icon: iconUrl(212956),
		duration: 15000,
		stacksApplied: 4,
	},
	ZOE: {
		id: 2611,
		name: 'Zoe',
		icon: iconUrl(212957),
		duration: 30000,
	},
	KRASIS: {
		id: 2622,
		name: 'Krasis',
		icon: iconUrl(212968),
		duration: 10000,
	},
	KERACHOLE: {
		id: 2618,
		name: 'Kerachole',
		icon: iconUrl(212964),
		duration: 15000,
	},
	KERAKEIA: { // The regen component of Kerachole
		id: 2938,
		name: 'Kerakeia',
		icon: iconUrl(212970),
		duration: 15000,
	},
	TAUROCHOLE: {
		id: 2619,
		name: 'Taurochole',
		icon: iconUrl(212965),
		duration: 15000,
	},
	EUKRASIAN_DOSIS: {
		id: 2614,
		name: 'Eukrasian Dosis',
		icon: iconUrl(212960),
		duration: 30000,
	},
	EUKRASIAN_DOSIS_II: {
		id: 2615,
		name: 'Eukrasian Dosis II',
		icon: iconUrl(212961),
		duration: 30000,
	},
	EUKRASIAN_DOSIS_III: {
		id: 2616,
		name: 'Eukrasian Dosis III',
		icon: iconUrl(212962),
		duration: 30000,
	},
	EUKRASIAN_DYSKRASIA: {
		id: 3897,
		name: 'Eukrasian Dyskrasia',
		icon: iconUrl(212973),
		duration: 30000,
	},
	PNEUMA: {
		id: 2623,
		name: 'Pneuma',
		icon: iconUrl(212969),
		duration: 20000,
	},
	HOLOS: {
		id: 3003,
		name: 'Holos',
		icon: iconUrl(212971),
		duration: 20000,
	},
	HOLOSAKOS: {
		id: 3365,
		name: 'Holosakos',
		icon: iconUrl(212972),
		duration: 30000,
	},
})
